import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSocial } from '../../context/socialProvider';
import GeneralSettings from './components/GeneralSettings';
import AutoModSettings from './components/AutoModSettings';
import CommentResponseSettings from './components/CommentResponseSettings';
import DmResponseSettings from './components/DmResponseSettings';

const SocialSettings = () => {
  const { providerId, providerName: routeProviderName } = useParams<{
    providerId: string;
    providerName: string;
  }>();
  const navigate = useNavigate();
  const { availableSocials } = useSocial();
  const [selectedSocial, setSelectedSocial] = useState<any | null>(null);
  const [expandedSection, setExpandedSection] = useState<string>('automod');

  useEffect(() => {
    if (!routeProviderName) {
      navigate('/global/settings');
      return;
    }

    if (providerId && routeProviderName && availableSocials.length > 0) {
      const decodedProviderName = decodeURIComponent(routeProviderName);
      const social = availableSocials.find(
        (s) =>
          s.id.toString() === providerId &&
          (s.providerName === decodedProviderName ||
            encodeURIComponent(s.providerName) === routeProviderName)
      );

      if (social) {
        setSelectedSocial(social);
      } else {
        navigate('/global/settings');
      }
    }
  }, [providerId, routeProviderName, availableSocials, navigate]);

  if (!selectedSocial) {
    return (
      <div className="h-screen bg-black flex items-center justify-center">
        <div className="animate-pulse text-white">
          Loading social account settings...
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="max-w-6xl mx-auto">
        {/* Navigation Tabs */}
        <div className="flex border-b border-gray-700 mb-6">
          {[
            { id: 'automod', label: 'AutoMod' },
            { id: 'comment-response', label: 'Comment Response' },
            { id: 'general', label: 'Profile' },
            { id: 'dm-response', label: 'DM Response' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setExpandedSection(tab.id)}
              className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
                expandedSection === tab.id
                  ? 'border-violet text-violet'
                  : 'border-transparent text-gray-400 hover:text-white'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Render appropriate section */}
        {expandedSection === 'general' && (
          <GeneralSettings selectedSocial={selectedSocial} />
        )}
        {expandedSection === 'automod' && (
          <AutoModSettings selectedSocial={selectedSocial} />
        )}
        {expandedSection === 'comment-response' && (
          <CommentResponseSettings selectedSocial={selectedSocial} />
        )}
        {expandedSection === 'dm-response' && (
          <DmResponseSettings selectedSocial={selectedSocial} />
        )}
      </div>
    </div>
  );
};

export default SocialSettings;
